import { Component, inject, input, Input, OnInit } from '@angular/core';
import {ChartStackedBarComponent} from "../chart-stacked-bar/chart-stacked-bar.component";
import {
  ChartDto,
  ReportRequestDto,
  ReportsService,
  ReportSummaryRowDto,
  SummarizeReportResponseDto,
  TotalsDto,
} from '../../../../api';
import {ReportsSummaryHeaderComponent} from '../reports-summary-header/reports-summary-header.component';
import {SummaryTableComponent} from '../summary-table/summary-table.component';
import {Divider} from 'primeng/divider';
import {ReportActionsComponent} from '../report-actions/report-actions.component';
import {ExportFormat} from '../../model/ExportFormat';

@Component({
  selector: 'app-summary-report',
  standalone: true,
  imports: [
    ChartStackedBarComponent,
    ReportsSummaryHeaderComponent,
    SummaryTableComponent,
    Divider,
    ReportActionsComponent,
  ],
  templateUrl: './summary-report.component.html',
  styleUrl: './summary-report.component.css',
})
export class SummaryReportComponent {
  private reportsService = inject(ReportsService);

  isOwner = input.required<boolean>();
  totals = input.required<TotalsDto>();
  chartData = input.required<ChartDto>();
  summaryData = input.required<Array<ReportSummaryRowDto>>();
  reportRequest = input.required<ReportRequestDto>();

  downloadSummaryReport = (
    workspaceId: string,
    format: ExportFormat,
    request: ReportRequestDto,
  ) => {
    return this.reportsService.summarizeReportExport(workspaceId, format, request, 'response');
  };
}
